import { useEffect } from "react";
import React, { useState } from "react";
import { frontDB } from "../../../../../frontDB";
import { useInvoices } from "../../useInvoices";
import styles from "./InvoicesHeader.module.css";
import { useInvoicesHeader } from "./useInvoicesHeader";
import CloseIcon from "@rsuite/icons/Close";
import { FiMenu } from "react-icons/fi";
import { CiBoxList } from "react-icons/ci";
import SearchFilter from "./SearchFilter";
import {
  InputNumber,
  Input,
  InputGroup,
  InputPicker,
  IconButton,
  DatePicker,
  DateRangePicker, // Changed to DateRangePicker
  Dropdown,
  Popover,
  Whisper,
} from "rsuite";
import MoreIcon from "@rsuite/icons/More";

import {
  showActive,
  getResponsibleName,
  filterUsers,
} from "../../../../../helperFunctions";
import {
  invoiceStatus,
  invoiceDepartments,
  currencyOptions,
  invoiceVesselsOptions,
} from "../../../../Settings/Data/lists";

import ExcelIcon from "./.../../../../../../Components/Components/ComponentsHeader/xlsx.png";

function InvoicesHeader() {
  let { showCreateInvoice } = useInvoices();

  let {
    filter,

    vesselHandler,
    departmentHandler,
    statusHandler,
    searchInputHandler,
    periodFromHandler,
    periodToHandler,
    userHandler,
    dueDateHandler,
    searchValues,
    searchClearHandler,
    getDueData,
    overdueInvoices,
    dueIn7Days,
    setFilterDepartment,
    setFilter,
    currencyHandler,
    onExport,
  } = useInvoicesHeader();

  let invoiceDepartmentOptions = [
    { label: "All departments", value: "*" },
    ...invoiceDepartments,
  ];

  const currencyFilterOptions = [
    { label: "All currencies", value: "*" },
    ...currencyOptions,
  ];

  const responsibleName = getResponsibleName();

  if (["FTM"].includes(responsibleName)) {
    invoiceDepartmentOptions = [
      { label: "All departments", value: "*" },
      { label: "Crewing", value: "Crewing" },
      { label: "Operations", value: "Operations" },
      { label: "Technical", value: "Technical" },
      { label: "Unassigned", value: "" },
    ];
  }

  if (["TSI", "MSI"].includes(responsibleName)) {
    invoiceDepartmentOptions = [
      { label: "All departments", value: "*" },
      { label: "Technical", value: "Technical" },
      { label: "Operations", value: "Operations" },
      { label: "Unassigned", value: "" },
    ];
  }

  if (["Crewing"].includes(responsibleName)) {
    invoiceDepartmentOptions = [
      { label: "Crewing", value: "Crewing" },
      { label: "Unassigned", value: "" },
    ];
  }

  const setDepartmentFilter = (responsibleName, department) => {
    if (department == "*") {
      if (["TSI"].includes(responsibleName)) {
        setFilterDepartment("*");
      }

      if (["FTM", "Crewing"].includes(responsibleName)) {
        setFilterDepartment("Crewing");
      }

      if (["MSI"].includes(responsibleName)) {
        setFilterDepartment("*");
      }
    }
  };

  useEffect(() => {
    //getWorkOrdersStatsByAllLocations();
    setDepartmentFilter(responsibleName, filter?.department);
    getDueData();
  }, []);

  let { users, locations } = frontDB();
  let userFilter = {
    location: "659a601d38d14accc6a6b0ec",
    status: "Active",
    responsible: "All responsibles",
  };
  let officeUsers = filterUsers(userFilter, users).map((item) => ({
    label: `${item.name}`,
    value: item._id,
  }));

  let officeUsersOptions = [{ label: "All users", value: "*" }, ...officeUsers];

  // let vesselOptions = [
  //   { label: "All vessels", value: "*" },
  //   ...showActive(locations)
  //     .filter((item) => item.name != "Office")
  //     .map((item) => ({ label: item.name, value: item._id })),
  // ];

  let vesselOptions = [
    { label: "All vessels", value: "*" },
    ...invoiceVesselsOptions,
  ];

  const isPaymentStatusAvailable = ["Admin", "Accounter"].includes(
    responsibleName,
  )
    ? true
    : false;
  const invoiceStatusOptions = [
    { label: "All statuses", value: "*" },
    ...invoiceStatus,
  ];

  let dueDateOptions = [
    { label: "Any Due Date", value: "*" },
    { label: "Overdue", value: "Overdue" },
    { label: "Due in 1 day", value: "1 day" },
    { label: "Due in 3 days", value: "3 days" },
    { label: "Due in 7 days", value: "7 days" },
    { label: "Due in 14 days", value: "14 days" },
  ];
  //const dateTo = getUTCDate(filter.to); //moment.utc(filter.to).startOf('day').toDate();
  const toolOverdue = (
    <Popover>Counted for invoices issued from 1st of March 2025</Popover>
  );

  // State for the selected filter option
  const [selectedFilterOption, setSelectedFilterOption] =
    useState("invoice_date");

  const handleSelect = (value) => {
    setSelectedFilterOption(value);
    console.log("selected: ", value);
  };

  const handleDateRangeChange = (value) => {
    if (value && value.length === 2) {
      setFilter((prev) => ({ ...prev, from: value[0], to: value[1] }));
    } else {
      // Handle null/undefined or single date (if needed)
      setFilter((prev) => ({ ...prev, from: null, to: null }));
    }
  };

  const tooltip = <Popover>Export Invoices</Popover>;
  const generateExportButton = (
    <div
      onClick={() => {
        onExport();
      }}
      style={{
        width: 35,
        height: 40,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        transition: "0.5s",
        backgroundColor: "transparent",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.3)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <Whisper
        delay={200}
        placement="top"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <img
          src={ExcelIcon}
          alt="Export to Excel"
          style={{ width: "100%", height: "100%" }}
        />
      </Whisper>
    </div>
  );

  return (
    <>
      <div className={styles.invoices_header}>
        <div className={styles.invoices_header_title}>Invoices</div>

        <div className={styles.invoices_header_options}>
          <InputPicker
            value={filter?.vesselName}
            onChange={vesselHandler}
            cleanable={false}
            placeholder="Select Vessel"
            data={vesselOptions}
            style={{ width: 185 }}
          />
          <InputPicker
            value={filter?.department}
            onChange={departmentHandler}
            cleanable={false}
            placeholder="Select Department"
            data={invoiceDepartmentOptions}
            style={{ width: 160 }}
          />

          <InputPicker
            value={filter?.status}
            onChange={statusHandler}
            cleanable={false}
            placeholder="Select Status"
            data={invoiceStatusOptions}
            style={{ width: 163 }}
          />

          <InputPicker
            value={filter?.userId}
            onChange={userHandler}
            cleanable={false}
            placeholder="Select User"
            data={officeUsersOptions}
            style={{ width: 160 }}
          />
          <InputPicker
            value={filter?.dueDateRange}
            onChange={dueDateHandler}
            cleanable={false}
            placeholder="Due date"
            data={dueDateOptions}
            style={{ width: 140 }}
          />
          <div
            style={{
              width: "150px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Dropdown
              placement="bottomEnd"
              renderToggle={(props, ref) => (
                <IconButton
                  {...props}
                  ref={ref}
                  icon={<FiMenu style={{ height: 20, width: 30 }} />}
                  appearance="subtle"
                  style={{
                    width: "auto",
                    height: 35,
                    marginLeft: 0,
                    display: "flex",
                    alignItems: "center",
                    padding: "0 12px",
                  }}
                >
                  {/* <span
                    style={{ marginTop: 1, marginLeft: 4, fontWeight: 500 }}
                  >
                    Export
                  </span> */}
                </IconButton>
              )}
            >
              <Dropdown.Item onClick={() => onExport()}>
                <div style={{ marginLeft: 15, width: 140 }}>
                  Export Invoices
                </div>
              </Dropdown.Item>
              <Dropdown.Item onClick={showCreateInvoice}>
                <div style={{ marginLeft: 15, width: 140 }}>Add Invoice</div>
              </Dropdown.Item>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className={styles.invoices_header_searchoptions}>
        {/* <div style={{ width: "107px" }}></div> */}
        <InputGroup inside style={{ width: "107px" }}>
          <Input
            value={searchValues?.invoiceId}
            className={styles.search_input}
            id="invoiceId"
            onChange={searchInputHandler}
            placeholder="#"
          />

          {searchValues?.invoiceId && (
            <InputGroup.Button
              id="company"
              onClick={() => searchClearHandler("invoiceId")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>

        <InputGroup inside style={{ width: "185px" }}>
          <Input
            value={searchValues?.company}
            className={styles.search_input}
            id="company"
            onChange={searchInputHandler}
            placeholder="Search by company"
          />

          {searchValues?.company && (
            <InputGroup.Button
              id="company"
              onClick={() => searchClearHandler("company")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        <InputGroup inside style={{ width: "160px" }}>
          <Input
            value={searchValues?.invoiceNumber}
            className={styles.search_input}
            id="invoiceNumber"
            onChange={searchInputHandler}
            placeholder="Invoice or PO"
          />
          {searchValues?.invoiceNumber && (
            <InputGroup.Button
              onClick={() => searchClearHandler("invoiceNumber")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        <div className={styles.date_pickers_container}>
          <SearchFilter />
          <InputPicker
            value={filter?.currency}
            onChange={currencyHandler}
            cleanable={false}
            placeholder="Currency"
            data={currencyFilterOptions}
            style={{ width: 140 }}
          />
        </div>

        <div style={{ width: 140, textAlign: "right" }}>
          <div style={{ fontSize: 12 }}>Overdue: {overdueInvoices}</div>
          <div style={{ fontSize: 12 }}>Due in 7 days: {dueIn7Days}</div>
        </div>
      </div>
    </>
  );
}

export default InvoicesHeader;

// function useInvoicesHeader() {
//   const [filter, setFilter] = useState({
//     vesselId: null,
//     department: null,
//     status: null,
//     userId: null,
//     dueDateRange: null,
//     from: null, // Initialize from and to
//     to: null,   // as null or undefined
//   });

//     const periodFromHandler = (date) => {
//     setFilter((prevFilter) => ({ ...prevFilter, from: date }));
//   };

//   const periodToHandler = (date) => {
//     setFilter((prevFilter) => ({ ...prevFilter, to: date }));
//   };
//   // ... other handlers ...

//   return {
//     filter,
//     setFilter, // Return setFilter
//     vesselHandler,
//     // ... other handlers and values ...
//   };
// }

// export default useInvoicesHeader;
